import { useState } from "react";

/**
 * Keeps a field's validation error out of sight while the user is still typing in
 * it: callers hide the error on every change and show it again on blur. Validation
 * itself keeps running on change, so anything derived from it — a submit button
 * gated on `isValid`, for instance — stays accurate.
 */
export const useFieldErrorVisibility = () => {
  const [visibleErrors, setVisibleErrors] = useState<Record<string, boolean>>(
    {},
  );

  return {
    visibleErrors,
    isErrorVisible: (field: string) => Boolean(visibleErrors[field]),
    hideError: (field: string) =>
      setVisibleErrors((current) =>
        current[field] ? { ...current, [field]: false } : current,
      ),
    showError: (field: string) =>
      setVisibleErrors((current) => ({ ...current, [field]: true })),
  };
};
